export default __webpack_public_path__ + "src/assets/UnstoppableDomains_Desktop.6b3875b99c1c23efd64fb863b01fcdef.svg";